import type { ComponentProps } from "react";

import classNames from "classnames";

import styles from "./ActionButton.module.scss";

export const ActionButton = ({ children, className, ...rest }: ComponentProps<"button">) => {
  return (
    <button {...rest} className={classNames(styles.button, className)}>
      {children}
    </button>
  );
};
